import { Injectable } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { BehaviorSubject, filter } from "rxjs";
import { PersonalizationService } from '@mydocma/app-container';
import { PersonalizationKeysEnum } from "@docma-mm-core/personalization/personalization-keys.enum";
import { GridOptions } from "ag-grid-community";
import { ColDefsService } from "../col-defs/col-defs.service";

@UntilDestroy()
@Injectable()
export class RowDefsService {

    private gridCurrentLineAmountSubject = new BehaviorSubject<number>(null);
    public gridCurrentLineAmount$ = this.gridCurrentLineAmountSubject.asObservable();

    private gridOptions: GridOptions;

    set currentLineAmount(amount: number) {
        this.gridCurrentLineAmountSubject.next(amount);
        this.personalizationService.setValue(PersonalizationKeysEnum.FaultGridLineAmount, amount);
    }

    get currentLineAmount(): number {
        return this.gridCurrentLineAmountSubject.value;
    }

    constructor(private readonly personalizationService: PersonalizationService,
                private readonly colDefsService: ColDefsService) {
        this.initialize();

        this.gridCurrentLineAmount$.pipe(untilDestroyed(this), filter(Boolean)).subscribe(() => {
            this.applyLineHeightToGrid();
          })
        }

    private async initialize() {
        this.gridCurrentLineAmountSubject.next(await this.personalizationService.getValue(PersonalizationKeysEnum.FaultGridLineAmount) || 1);
    }

    public attach(gridOptions: GridOptions) {
        this.gridOptions = gridOptions;
        this.applyLineHeightToGrid();
    }

    public applyLineHeightToGrid() {

        if(!this.gridOptions) return;
        switch(this.currentLineAmount) {
            case 1:
                if(this.colDefsService.imageColumnActive) {
                    this.gridOptions.rowHeight = 40;
                    if (this.gridOptions?.api) {
                    this.gridOptions.api?.setHeaderHeight(48);
                    } else {
                    this.gridOptions.headerHeight = 48;
                    }
                } else {
                    this.gridOptions.rowHeight = 32;
                    if (this.gridOptions?.api) {
                        this.gridOptions.api?.setHeaderHeight(40);
                    } else {
                        this.gridOptions.headerHeight = 40;
                    }
                }
                break;
            case 2:
                this.gridOptions.rowHeight = 48;
                this.gridOptions.headerHeight = 48;
                this.gridOptions.api?.setHeaderHeight(48);

                break;
            case 3:
                this.gridOptions.rowHeight = 52;
                this.gridOptions.headerHeight = 48;
                this.gridOptions.api?.setHeaderHeight(48);
                break;
            case 4:
                this.gridOptions.rowHeight = 64;
                this.gridOptions.headerHeight = 48;
                this.gridOptions.api?.setHeaderHeight(48);
                break;
            }

            if(this.gridOptions.api) {
                this.gridOptions.api.resetRowHeights();
                this.gridOptions.api.setHeaderHeight(this.gridOptions.headerHeight);
            }
    }
}
